import { Item } from "app/models/item.inferface";

export class RolestFakeDb
{
    public static roles: Item[] = [
        {
            id: 1,
            description: 'Administrator'           
        },
        {
            id: 2,
            description: 'Role 2'          
        },
        {
            id: 3,
            description: 'Role 3'
        },
        {
            id: 4,
            description: 'Role 4'
        }
    ];
}
